import type { ApiError } from "../../shared/api/queryClient";

export const HOLIDAY_ERRORS: Record<string, string> = {
  HOLIDAY_DUPLICATE: "Já existe um feriado nesta data para esta cidade.",
  HOLIDAY_LOCKED: "Feriados nacionais e estaduais semeados não podem ser desativados.",
};

/** Mensagem pt-BR de um erro das escritas de feriado (INVALID_HOLIDAY e demais: a mensagem do BE). */
export function holidayErrorMessage(error: unknown, fallback: string): string {
  const e = error as Partial<ApiError> | null;
  if (e?.code && HOLIDAY_ERRORS[e.code]) return HOLIDAY_ERRORS[e.code];
  return e?.message || fallback;
}
